import React, { useCallback, useState } from "react";
import { Empty, Table } from "antd";
import { COMPLETED_REPORT_STATUSES } from "./utils";

const DEFAULT_PAGE_SIZE = 100;
export const disableReportDelay = (status) => COMPLETED_REPORT_STATUSES.includes(status);

const ReportDelayTableRow = ({ className, ...antdProps }) => (
  <tr
    {...antdProps} // eslint-disable-line react/jsx-props-no-spreading
    className={className ? `ReportDelayTableRow ${className}` : "ReportDelayTableRow"}
  />
);

const ReportDelayTableCell = (props) => (
  <td
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  />
);

export default function ReportDelayTable({
  dataSource,
  columns,
  loading = false,
  scroll,
  emptyText,
  onRow,
  className = "ReportDelayTable",
  rowKey = "key",
  rowSelectionVisible = false,
  selectedRowKeys,
  onCheckboxChange,
  onSelectChange,
  selectionCounter,
  pagination = false,
  tableLayout,
  sticky = true,
}) {
  const totalData = dataSource && Array.isArray(dataSource) ? dataSource.length : 10;
  const [paginationConfig, setPaginationConfig] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    total: totalData,
    pageSizeOptions: [10, 50, 100, 200],
    ...(typeof pagination === "object" ? pagination : {}),
  });

  const handlePageChange = (page, pageSize) => {
    setPaginationConfig((prevState) => ({
      ...prevState,
      current: page,
      pageSize,
    }));
  };

  const handleClearAllChecks = () => {
    if (onCheckboxChange) onCheckboxChange([]);
  };

  const getCheckboxProps = useCallback((record) => ({
    disabled: disableReportDelay(record.status),
  }), []);

  const rowSelection = rowSelectionVisible
    ? {
      type: "checkbox",
      selectedRowKeys: selectedRowKeys ?? [],
      onChange: onCheckboxChange ?? (() => {}),
      ...(onSelectChange ? { onSelect: (record) => onSelectChange(record) } : {}),
      getCheckboxProps,
      columnWidth: 80,
      ...(selectionCounter != null
        ? {
          columnTitle: (node) => (
            <div className="ReportDelayTable__SelectAllCheckbox">
              {node}
              <span className="ReportDelayTable__Counter">{selectionCounter}</span>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  handleClearAllChecks();
                }}
                role="presentation"
              >
                <i className="fa fa-times reportDelayTable__ClearSelectionIcon" />
              </span>
            </div>
          ),
        }
        : {}),
    }
    : undefined;

  return (
    <Table
      sticky={sticky}
      tableLayout={tableLayout}
      className={className}
      dataSource={dataSource}
      columns={columns}
      rowKey={rowKey}
      scroll={scroll}
      pagination={pagination === false ? false : {
        ...paginationConfig,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
        onChange: handlePageChange,
      }}
      loading={loading}
      bordered
      rowHoverable
      onRow={onRow}
      rowSelection={rowSelection}
      locale={emptyText ? {
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
        ),
      } : undefined}
      components={{
        body: {
          row: ReportDelayTableRow,
          cell: ReportDelayTableCell,
        },
      }}
    />
  );
}
